import Joi from '@hapi/joi';

export const findingCreateSchema = Joi.object().keys({
    description: Joi.string().allow(null, ''),
});
